// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"958bef33","125":"6541cb5d","333":"63d5a04b","391":"60c04234","453":"b00bc60c","735":"8850f432"}[chunkId] + ".chunk.js";
};